<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2 class="font-bold">舟向进气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">排水阀打开</div>
          <div class="stopped">排水阀关闭</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor2 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZ1, drainAJZ1) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZ1, drainBJZ1) }}
              </div>
              <div :class="errorJZ1" class="state-info right-pos">
                <p>JZ1气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZ1 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZ1" class="valve-sign"></span> <span :class="drainBClassJZ1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-left-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZ3, drainAJZ3) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZ3, drainBJZ3) }}
              </div>
              <div :class="errorJZ3" class="state-info right-pos">
                <p>JZ3气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZ3 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZ3" class="valve-sign"></span> <span :class="drainBClassJZ3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM5, drainAJZM5) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM5, drainBJZM5) }}
              </div>
              <div :class="errorJZM5" class="state-info left-pos">
                <p>JZM5气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM5 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM5" class="valve-sign"></span> <span :class="drainBClassJZM5" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM3, drainAJZM3) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM3, drainBJZM3) }}
              </div>
              <div :class="errorJZM3" class="state-info left-pos">
                <p>JZM3气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM3 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM3" class="valve-sign"></span> <span :class="drainBClassJZM3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM1, drainAJZM1) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM1, drainBJZM1) }}
              </div>
              <div :class="errorJZM1" class="state-info right-pos">
                <p>JZM1气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM1 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM1" class="valve-sign"></span> <span :class="drainBClassJZM1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM1Plus, drainAJZM1Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM1Plus, drainBJZM1Plus) }}
              </div>
              <div :class="errorJZM1Plus" class="state-info left-pos">
                <p>JZM1+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM1Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM1Plus" class="valve-sign"></span> <span :class="drainBClassJZM1Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM3Plus, drainAJZM3Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM3Plus, drainBJZM3Plus) }}
              </div>
              <div :class="errorJZM3Plus" class="state-info right-pos">
                <p>JZM3+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM3Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM3Plus" class="valve-sign"></span> <span :class="drainBClassJZM3Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZM5Plus, drainAJZM5Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZM5Plus, drainBJZM5Plus) }}
              </div>
              <div :class="errorJZM5Plus" class="state-info right-pos">
                <p>JZM5+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZM5Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZM5Plus" class="valve-sign"></span> <span :class="drainBClassJZM5Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZ3Plus, drainAJZ3Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZ3Plus, drainBJZ3Plus) }}
              </div>
              <div :class="errorJZ3Plus" class="state-info left-pos">
                <p>JZ3+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZ3Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZ3Plus" class="valve-sign"></span> <span :class="drainBClassJZ3Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJZ1Plus, drainAJZ1Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJZ1Plus, drainBJZ1Plus) }}
              </div>
              <div :class="errorJZ1Plus" class="state-info left-pos">
                <p>JZ1+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJZ1Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJZ1Plus" class="valve-sign"></span> <span :class="drainBClassJZ1Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>舟向排气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">排水阀打开</div>
          <div class="stopped">排水阀关闭</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ0, drainAPZ0) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ0, drainBPZ0) }}
              </div>
              <div :class="errorPZ0" class="state-info right-pos">
                <p>PZ0气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ0 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ0" class="valve-sign"></span> <span :class="drainBClassPZ0" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ2, drainAPZ2) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ2, drainBPZ2) }}
              </div>
              <div :class="errorPZ2" class="state-info right-pos">
                <p>PZ2气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ2 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ2" class="valve-sign"></span> <span :class="drainBClassPZ2" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ4, drainAPZ4) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ4, drainBPZ4) }}
              </div>
              <div :class="errorPZ4" class="state-info right-pos">
                <p>PZ4气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ4 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ4" class="valve-sign"></span> <span :class="drainBClassPZ4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM6, drainAPZM6) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM6, drainBPZM6) }}
              </div>
              <div :class="errorPZM6" class="state-info left-pos">
                <p>PZM6气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM6 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM6" class="valve-sign"></span> <span :class="drainBClassPZM6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM4, drainAPZM4) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM4, drainBPZM4) }}
              </div>
              <div :class="errorPZM4" class="state-info left-pos">
                <p>PZM4气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM4 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM4" class="valve-sign"></span> <span :class="drainBClassPZM4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM2, drainAPZM2) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM2, drainBPZM2) }}
              </div>
              <div :class="errorPZM2" class="state-info right-pos">
                <p>PZM2气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM2 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM2" class="valve-sign"></span> <span :class="drainBClassPZM2" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM0, drainAPZM0) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM0, drainBPZM0) }}
              </div>
              <div :class="errorPZM0" class="state-info top-pos">
                <p>PZM0气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM0 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM0" class="valve-sign"></span> <span :class="drainBClassPZM0" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM2Plus, drainAPZM2Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM2Plus, drainBPZM2Plus) }}
              </div>
              <div :class="errorPZM2Plus" class="state-info left-pos">
                <p>PZM2+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM2Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM2Plus" class="valve-sign"></span> <span :class="drainBClassPZM2Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM4Plus, drainAPZM4Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM4Plus, drainBPZM4Plus) }}
              </div>
              <div :class="errorPZM4Plus" class="state-info right-pos">
                <p>PZM4+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM4Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM4Plus" class="valve-sign"></span> <span :class="drainBClassPZM4Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZM6Plus, drainAPZM6Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZM6Plus, drainBPZM6Plus) }}
              </div>
              <div :class="errorPZM6Plus" class="state-info right-pos">
                <p>PZM6+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZM6Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZM6Plus" class="valve-sign"></span> <span :class="drainBClassPZM6Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ4Plus, drainAPZ4Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ4Plus, drainBPZ4Plus) }}
              </div>
              <div :class="errorPZ4Plus" class="state-info left-pos">
                <p>PZ4+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ4Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ4Plus" class="valve-sign"></span> <span :class="drainBClassPZ4Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ2Plus, drainAPZ2Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ2Plus, drainBPZ2Plus) }}
              </div>
              <div :class="errorPZ2Plus" class="state-info left-pos">
                <p>PZ2+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ2Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ2Plus" class="valve-sign"></span> <span :class="drainBClassPZ2Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPZ0Plus, drainAPZ0Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPZ0Plus, drainBPZ0Plus) }}
              </div>
              <div :class="errorPZ0Plus" class="state-info left-pos">
                <p>PZ0+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePZ0Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPZ0Plus" class="valve-sign"></span> <span :class="drainBClassPZ0Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //valve drain
      valvePZ0: "--",
      valvePN0: "--",
      valveJZ1: "--",
      valveJN1: "--",
      valvePZ2: "--",
      valvePN2: "--",
      valveJZ3: "--",
      valveJN3: "--",
      valvePZ4: "--",
      valvePN4: "--",
      valvePZM6: "--",
      valvePNM6: "--",
      valveJZM5: "--",
      valveJNM5: "--",
      valvePZM4: "--",
      valvePNM4: "--",
      valveJZM3: "--",
      valveJNM3: "--",
      valvePZM2: "--",
      valvePNM2: "--",
      valveJZM1: "--",
      valveJNM1: "--",
      valvePZM0: "--",
      valvePNM0: "--",
      valvePZ0Plus: "--",
      valvePN0Plus: "--",
      valveJZ1Plus: "--",
      valveJN1Plus: "--",
      valvePZ2Plus: "--",
      valvePN2Plus: "--",
      valveJZ3Plus: "--",
      valveJN3Plus: "--",
      valvePZ4Plus: "--",
      valvePN4Plus: "--",
      valvePZM6Plus: "--",
      valvePNM6Plus: "--",
      valveJZM5Plus: "--",
      valveJNM5Plus: "--",
      valvePZM4Plus: "--",
      valvePNM4Plus: "--",
      valveJZM3Plus: "--",
      valveJNM3Plus: "--",
      valvePZM2Plus: "--",
      valvePNM2Plus: "--",
      valveJZM1Plus: "--",
      valveJNM1Plus: "--",

      drainAPZ0: "--",
      drainAPN0: "--",
      drainAJZ1: "--",
      drainAJN1: "--",
      drainAPZ2: "--",
      drainAPN2: "--",
      drainAJZ3: "--",
      drainAJN3: "--",
      drainAPZ4: "--",
      drainAPN4: "--",
      drainAPZM6: "--",
      drainAPNM6: "--",
      drainAJZM5: "--",
      drainAJNM5: "--",
      drainAPZM4: "--",
      drainAPNM4: "--",
      drainAJZM3: "--",
      drainAJNM3: "--",
      drainAPZM2: "--",
      drainAPNM2: "--",
      drainAJZM1: "--",
      drainAJNM1: "--",
      drainAPZM0: "--",
      drainAPNM0: "--",
      drainAPZ0Plus: "--",
      drainAPN0Plus: "--",
      drainAJZ1Plus: "--",
      drainAJN1Plus: "--",
      drainAPZ2Plus: "--",
      drainAPN2Plus: "--",
      drainAJZ3Plus: "--",
      drainAJN3Plus: "--",
      drainAPZ4Plus: "--",
      drainAPN4Plus: "--",
      drainAPZM6Plus: "--",
      drainAPNM6Plus: "--",
      drainAJZM5Plus: "--",
      drainAJNM5Plus: "--",
      drainAPZM4Plus: "--",
      drainAPNM4Plus: "--",
      drainAJZM3Plus: "--",
      drainAJNM3Plus: "--",
      drainAPZM2Plus: "--",
      drainAPNM2Plus: "--",
      drainAJZM1Plus: "--",
      drainAJNM1Plus: "--",

      drainBPZ0: "--",
      drainBPN0: "--",
      drainBJZ1: "--",
      drainBJN1: "--",
      drainBPZ2: "--",
      drainBPN2: "--",
      drainBJZ3: "--",
      drainBJN3: "--",
      drainBPZ4: "--",
      drainBPN4: "--",
      drainBPZM6: "--",
      drainBPNM6: "--",
      drainBJZM5: "--",
      drainBJNM5: "--",
      drainBPZM4: "--",
      drainBPNM4: "--",
      drainBJZM3: "--",
      drainBJNM3: "--",
      drainBPZM2: "--",
      drainBPNM2: "--",
      drainBJZM1: "--",
      drainBJNM1: "--",
      drainBPZM0: "--",
      drainBPNM0: "--",
      drainBPZ0Plus: "--",
      drainBPN0Plus: "--",
      drainBJZ1Plus: "--",
      drainBJN1Plus: "--",
      drainBPZ2Plus: "--",
      drainBPN2Plus: "--",
      drainBJZ3Plus: "--",
      drainBJN3Plus: "--",
      drainBPZ4Plus: "--",
      drainBPN4Plus: "--",
      drainBPZM6Plus: "--",
      drainBPNM6Plus: "--",
      drainBJZM5Plus: "--",
      drainBJNM5Plus: "--",
      drainBPZM4Plus: "--",
      drainBPNM4Plus: "--",
      drainBJZM3Plus: "--",
      drainBJNM3Plus: "--",
      drainBPZM2Plus: "--",
      drainBPNM2Plus: "--",
      drainBJZM1Plus: "--",
      drainBJNM1Plus: "--",

      //error
      errorPZ0: "--",
      errorPN0: "--",
      errorJZ1: "--",
      errorJN1: "--",
      errorPZ2: "--",
      errorPN2: "--",
      errorJZ3: "--",
      errorJN3: "--",
      errorPZ4: "--",
      errorPN4: "--",
      errorPZM6: "--",
      errorPNM6: "--",
      errorJZM5: "--",
      errorJNM5: "--",
      errorPZM4: "--",
      errorPNM4: "--",
      errorJZM3: "--",
      errorJNM3: "--",
      errorPZM2: "--",
      errorPNM2: "--",
      errorJZM1: "--",
      errorJNM1: "--",
      errorPZM0: "--",
      errorPNM0: "--",
      errorPZ0Plus: "--",
      errorPN0Plus: "--",
      errorJZ1Plus: "--",
      errorJN1Plus: "--",
      errorPZ2Plus: "--",
      errorPN2Plus: "--",
      errorJZ3Plus: "--",
      errorJN3Plus: "--",
      errorPZ4Plus: "--",
      errorPN4Plus: "--",
      errorPZM6Plus: "--",
      errorPNM6Plus: "--",
      errorJZM5Plus: "--",
      errorJNM5Plus: "--",
      errorPZM4Plus: "--",
      errorPNM4Plus: "--",
      errorJZM3Plus: "--",
      errorJNM3Plus: "--",
      errorPZM2Plus: "--",
      errorPNM2Plus: "--",
      errorJZM1Plus: "--",
      errorJNM1Plus: "--",

      errorDrainAPZ0: "--",
      errorDrainAPN0: "--",
      errorDrainAJZ1: "--",
      errorDrainAJN1: "--",
      errorDrainAPZ2: "--",
      errorDrainAPN2: "--",
      errorDrainAJZ3: "--",
      errorDrainAJN3: "--",
      errorDrainAPZ4: "--",
      errorDrainAPN4: "--",
      errorDrainAPZM6: "--",
      errorDrainAPNM6: "--",
      errorDrainAJZM5: "--",
      errorDrainAJNM5: "--",
      errorDrainAPZM4: "--",
      errorDrainAPNM4: "--",
      errorDrainAJZM3: "--",
      errorDrainAJNM3: "--",
      errorDrainAPZM2: "--",
      errorDrainAPNM2: "--",
      errorDrainAJZM1: "--",
      errorDrainAJNM1: "--",
      errorDrainAPZM0: "--",
      errorDrainAPNM0: "--",
      errorDrainAPZ0Plus: "--",
      errorDrainAPN0Plus: "--",
      errorDrainAJZ1Plus: "--",
      errorDrainAJN1Plus: "--",
      errorDrainAPZ2Plus: "--",
      errorDrainAPN2Plus: "--",
      errorDrainAJZ3Plus: "--",
      errorDrainAJN3Plus: "--",
      errorDrainAPZ4Plus: "--",
      errorDrainAPN4Plus: "--",
      errorDrainAPZM6Plus: "--",
      errorDrainAPNM6Plus: "--",
      errorDrainAJZM5Plus: "--",
      errorDrainAJNM5Plus: "--",
      errorDrainAPZM4Plus: "--",
      errorDrainAPNM4Plus: "--",
      errorDrainAJZM3Plus: "--",
      errorDrainAJNM3Plus: "--",
      errorDrainAPZM2Plus: "--",
      errorDrainAPNM2Plus: "--",
      errorDrainAJZM1Plus: "--",
      errorDrainAJNM1Plus: "--",

      errorDrainBPZ0: "--",
      errorDrainBPN0: "--",
      errorDrainBJZ1: "--",
      errorDrainBJN1: "--",
      errorDrainBPZ2: "--",
      errorDrainBPN2: "--",
      errorDrainBJZ3: "--",
      errorDrainBJN3: "--",
      errorDrainBPZ4: "--",
      errorDrainBPN4: "--",
      errorDrainBPZM6: "--",
      errorDrainBPNM6: "--",
      errorDrainBJZM5: "--",
      errorDrainBJNM5: "--",
      errorDrainBPZM4: "--",
      errorDrainBPNM4: "--",
      errorDrainBJZM3: "--",
      errorDrainBJNM3: "--",
      errorDrainBPZM2: "--",
      errorDrainBPNM2: "--",
      errorDrainBJZM1: "--",
      errorDrainBJNM1: "--",
      errorDrainBPZM0: "--",
      errorDrainBPNM0: "--",
      errorDrainBPZ0Plus: "--",
      errorDrainBPN0Plus: "--",
      errorDrainBJZ1Plus: "--",
      errorDrainBJN1Plus: "--",
      errorDrainBPZ2Plus: "--",
      errorDrainBPN2Plus: "--",
      errorDrainBJZ3Plus: "--",
      errorDrainBJN3Plus: "--",
      errorDrainBPZ4Plus: "--",
      errorDrainBPN4Plus: "--",
      errorDrainBPZM6Plus: "--",
      errorDrainBPNM6Plus: "--",
      errorDrainBJZM5Plus: "--",
      errorDrainBJNM5Plus: "--",
      errorDrainBPZM4Plus: "--",
      errorDrainBPNM4Plus: "--",
      errorDrainBJZM3Plus: "--",
      errorDrainBJNM3Plus: "--",
      errorDrainBPZM2Plus: "--",
      errorDrainBPNM2Plus: "--",
      errorDrainBJZM1Plus: "--",
      errorDrainBJNM1Plus: "--",

      //drain tooltip
      drainATooltipPZ0: "--",
      drainATooltipPN0: "--",
      drainATooltipJZ1: "--",
      drainATooltipJN1: "--",
      drainATooltipPZ2: "--",
      drainATooltipPN2: "--",
      drainATooltipJZ3: "--",
      drainATooltipJN3: "--",
      drainATooltipPZ4: "--",
      drainATooltipPN4: "--",
      drainATooltipPZM6: "--",
      drainATooltipPNM6: "--",
      drainATooltipJZM5: "--",
      drainATooltipJNM5: "--",
      drainATooltipPZM4: "--",
      drainATooltipPNM4: "--",
      drainATooltipJZM3: "--",
      drainATooltipJNM3: "--",
      drainATooltipPZM2: "--",
      drainATooltipPNM2: "--",
      drainATooltipJZM1: "--",
      drainATooltipJNM1: "--",
      drainATooltipPZM0: "--",
      drainATooltipPNM0: "--",
      drainATooltipPZ0Plus: "--",
      drainATooltipPN0Plus: "--",
      drainATooltipJZ1Plus: "--",
      drainATooltipJN1Plus: "--",
      drainATooltipPZ2Plus: "--",
      drainATooltipPN2Plus: "--",
      drainATooltipJZ3Plus: "--",
      drainATooltipJN3Plus: "--",
      drainATooltipPZ4Plus: "--",
      drainATooltipPN4Plus: "--",
      drainATooltipPZM6Plus: "--",
      drainATooltipPNM6Plus: "--",
      drainATooltipJZM5Plus: "--",
      drainATooltipJNM5Plus: "--",
      drainATooltipPZM4Plus: "--",
      drainATooltipPNM4Plus: "--",
      drainATooltipJZM3Plus: "--",
      drainATooltipJNM3Plus: "--",
      drainATooltipPZM2Plus: "--",
      drainATooltipPNM2Plus: "--",
      drainATooltipJZM1Plus: "--",
      drainATooltipJNM1Plus: "--",

      drainBTooltipPZ0: "--",
      drainBTooltipPN0: "--",
      drainBTooltipJZ1: "--",
      drainBTooltipJN1: "--",
      drainBTooltipPZ2: "--",
      drainBTooltipPN2: "--",
      drainBTooltipJZ3: "--",
      drainBTooltipJN3: "--",
      drainBTooltipPZ4: "--",
      drainBTooltipPN4: "--",
      drainBTooltipPZM6: "--",
      drainBTooltipPNM6: "--",
      drainBTooltipJZM5: "--",
      drainBTooltipJNM5: "--",
      drainBTooltipPZM4: "--",
      drainBTooltipPNM4: "--",
      drainBTooltipJZM3: "--",
      drainBTooltipJNM3: "--",
      drainBTooltipPZM2: "--",
      drainBTooltipPNM2: "--",
      drainBTooltipJZM1: "--",
      drainBTooltipJNM1: "--",
      drainBTooltipPZM0: "--",
      drainBTooltipPNM0: "--",
      drainBTooltipPZ0Plus: "--",
      drainBTooltipPN0Plus: "--",
      drainBTooltipJZ1Plus: "--",
      drainBTooltipJN1Plus: "--",
      drainBTooltipPZ2Plus: "--",
      drainBTooltipPN2Plus: "--",
      drainBTooltipJZ3Plus: "--",
      drainBTooltipJN3Plus: "--",
      drainBTooltipPZ4Plus: "--",
      drainBTooltipPN4Plus: "--",
      drainBTooltipPZM6Plus: "--",
      drainBTooltipPNM6Plus: "--",
      drainBTooltipJZM5Plus: "--",
      drainBTooltipJNM5Plus: "--",
      drainBTooltipPZM4Plus: "--",
      drainBTooltipPNM4Plus: "--",
      drainBTooltipJZM3Plus: "--",
      drainBTooltipJNM3Plus: "--",
      drainBTooltipPZM2Plus: "--",
      drainBTooltipPNM2Plus: "--",
      drainBTooltipJZM1Plus: "--",
      drainBTooltipJNM1Plus: "--",

      //running class
      drainAClassPZ0: "--",
      drainAClassPN0: "--",
      drainAClassJZ1: "--",
      drainAClassJN1: "--",
      drainAClassPZ2: "--",
      drainAClassPN2: "--",
      drainAClassJZ3: "--",
      drainAClassJN3: "--",
      drainAClassPZ4: "--",
      drainAClassPN4: "--",
      drainAClassPZM6: "--",
      drainAClassPNM6: "--",
      drainAClassJZM5: "--",
      drainAClassJNM5: "--",
      drainAClassPZM4: "--",
      drainAClassPNM4: "--",
      drainAClassJZM3: "--",
      drainAClassJNM3: "--",
      drainAClassPZM2: "--",
      drainAClassPNM2: "--",
      drainAClassJZM1: "--",
      drainAClassJNM1: "--",
      drainAClassPZM0: "--",
      drainAClassPNM0: "--",
      drainAClassPZ0Plus: "--",
      drainAClassPN0Plus: "--",
      drainAClassJZ1Plus: "--",
      drainAClassJN1Plus: "--",
      drainAClassPZ2Plus: "--",
      drainAClassPN2Plus: "--",
      drainAClassJZ3Plus: "--",
      drainAClassJN3Plus: "--",
      drainAClassPZ4Plus: "--",
      drainAClassPN4Plus: "--",
      drainAClassPZM6Plus: "--",
      drainAClassPNM6Plus: "--",
      drainAClassJZM5Plus: "--",
      drainAClassJNM5Plus: "--",
      drainAClassPZM4Plus: "--",
      drainAClassPNM4Plus: "--",
      drainAClassJZM3Plus: "--",
      drainAClassJNM3Plus: "--",
      drainAClassPZM2Plus: "--",
      drainAClassPNM2Plus: "--",
      drainAClassJZM1Plus: "--",
      drainAClassJNM1Plus: "--",

      drainBClassPZ0: "--",
      drainBClassPN0: "--",
      drainBClassJZ1: "--",
      drainBClassJN1: "--",
      drainBClassPZ2: "--",
      drainBClassPN2: "--",
      drainBClassJZ3: "--",
      drainBClassJN3: "--",
      drainBClassPZ4: "--",
      drainBClassPN4: "--",
      drainBClassPZM6: "--",
      drainBClassPNM6: "--",
      drainBClassJZM5: "--",
      drainBClassJNM5: "--",
      drainBClassPZM4: "--",
      drainBClassPNM4: "--",
      drainBClassJZM3: "--",
      drainBClassJNM3: "--",
      drainBClassPZM2: "--",
      drainBClassPNM2: "--",
      drainBClassJZM1: "--",
      drainBClassJNM1: "--",
      drainBClassPZM0: "--",
      drainBClassPNM0: "--",
      drainBClassPZ0Plus: "--",
      drainBClassPN0Plus: "--",
      drainBClassJZ1Plus: "--",
      drainBClassJN1Plus: "--",
      drainBClassPZ2Plus: "--",
      drainBClassPN2Plus: "--",
      drainBClassJZ3Plus: "--",
      drainBClassJN3Plus: "--",
      drainBClassPZ4Plus: "--",
      drainBClassPN4Plus: "--",
      drainBClassPZM6Plus: "--",
      drainBClassPNM6Plus: "--",
      drainBClassJZM5Plus: "--",
      drainBClassJNM5Plus: "--",
      drainBClassPZM4Plus: "--",
      drainBClassPNM4Plus: "--",
      drainBClassJZM3Plus: "--",
      drainBClassJNM3Plus: "--",
      drainBClassPZM2Plus: "--",
      drainBClassPNM2Plus: "--",
      drainBClassJZM1Plus: "--",
      drainBClassJNM1Plus: "--",

      dataNameIdDict: {
        //valve drain
        valvePZ0: "ae1f4e32-4ff8-494b-a2f8-621777dc369d",
        valvePN0: "909ae7b7-05d9-404f-8b41-70c478c407ad",
        valveJZ1: "ffa3f213-b9ac-4138-abbe-a676aa54c861",
        valveJN1: "06a3468a-62f5-470e-a54a-32afcd1e3484",
        valvePZ2: "4b69e252-834e-4e9e-a895-d27cb406d63d",
        valvePN2: "b3dff8bf-ecd5-48d9-93e7-8de88f40ae79",
        valveJZ3: "7a1d57b5-40ee-46ec-82f4-2bf399daa476",
        valveJN3: "5e79fb6e-8f61-4b0e-94cd-56dadeadc264",
        valvePZ4: "9538c423-be8a-4f13-961d-ed3606fdefb5",
        valvePN4: "606a1a45-eaa3-42fd-a4ab-f6be8ffefb0b",
        valvePZM6: "ccb976ec-7edd-44db-9452-d3ac45e4173c",
        valvePNM6: "918053ad-be54-4710-9988-64ead210dc53",
        valveJZM5: "4cdaab80-6aa1-43ba-a634-317709b1813d",
        valveJNM5: "aef769ff-4924-4df5-bb88-0f986aa8d35f",
        valvePZM4: "f9f92a3e-b85c-4958-a1f0-ff4f62d2bb16",
        valvePNM4: "81fae80e-0b5b-42cd-bab4-bdc4d95e027f",
        valveJZM3: "18771d9a-995c-4fcd-b75f-42de8b86b610",
        valveJNM3: "c2bbb989-661a-4c1d-95dd-e4024e50f3ed",
        valvePZM2: "65a5e388-5b49-48b8-b582-d67db0bd6066",
        valvePNM2: "196f69f6-697c-40e1-a887-5e6b99fc6700",
        valveJZM1: "060811bb-1244-4ac5-b340-d0ecfce02290",
        valveJNM1: "bc132c7d-a41b-43c1-8fa9-91fc3d46b460",
        valvePZM0: "0faa00b2-a4eb-470a-b9f5-4048fb2fe61f",
        valvePNM0: "c1607c9d-2bb3-4a0c-b1d5-45aaf7134598",
        valvePZ0Plus: "7e38ad38-c49c-411c-8ce3-75e97d962ce1",
        valvePN0Plus: "23b01ee2-e311-4412-92d9-49650dc15d28",
        valveJZ1Plus: "e2fec875-a84e-4aef-91b8-0eb0de87b906",
        valveJN1Plus: "0d989685-c846-4195-a53e-d4c671f64005",
        valvePZ2Plus: "459b87f1-dd9e-42d2-ad57-3f183f78e37f",
        valvePN2Plus: "49bbb249-b289-41e9-82e9-c72296f1c000",
        valveJZ3Plus: "a0ee0415-0238-483e-ad64-decd26288d52",
        valveJN3Plus: "e1f30062-4cc2-49ae-baa3-1697d959a3ac",
        valvePZ4Plus: "1079444e-0044-4058-87ab-b667663867cf",
        valvePN4Plus: "3e6edf9f-fae2-451b-bd55-980c54e21f03",
        valvePZM6Plus: "9f7a7ca4-971b-4419-a863-6b6b0ce5e5d6",
        valvePNM6Plus: "456bf547-d871-495f-b907-8c15e298882b",
        valveJZM5Plus: "f41b5a61-1c73-44e5-bf9b-587189513648",
        valveJNM5Plus: "7085f5ce-3ead-4b63-85ca-eb695c4a0cc4",
        valvePZM4Plus: "7cacd9c1-fc21-42a3-af7f-d204c05618f4",
        valvePNM4Plus: "720485de-5dd0-4d3a-9889-bc4f3f85d00a",
        valveJZM3Plus: "ed4b6f72-b0b9-4204-af7d-1286543cb830",
        valveJNM3Plus: "d998a13a-eaa5-438f-b29f-9fb9d64ab75e",
        valvePZM2Plus: "b92c225f-b548-48ac-8012-ea57fd10180f",
        valvePNM2Plus: "e176ec29-7a68-4ed9-be7d-c25013e23dc2",
        valveJZM1Plus: "7d6f5d7d-3531-4f00-a429-10de814c5dad",
        valveJNM1Plus: "26cd2c7f-1f08-4d81-b51d-17b29d1b825f",

        drainAPZ0: "fb77437d-18de-42e9-9399-dfd0766d9543",
        drainAPN0: "bdae71de-b5e8-4f6f-9e4c-6bbb6d9ce0e1",
        drainAJZ1: "d9ac2054-6e61-479d-8651-97a6c44590bb",
        drainAJN1: "13d88346-6ef9-4f70-9a32-5441b13e3c15",
        drainAPZ2: "21b4c860-61e6-4209-bb17-834ca2da85af",
        drainAPN2: "f1de72df-a6ac-46de-88e7-af48777bb19d",
        drainAJZ3: "a478e456-fb19-4a16-ac6e-b014412dd448",
        drainAJN3: "a6a9f983-807b-4645-8498-5c8edec0fe4c",
        drainAPZ4: "6cb4776e-51de-4bdf-95a2-49e7e9c9d22a",
        drainAPN4: "fcec224c-d121-4dbd-9dfc-03ababcbf39d",
        drainAPZM6: "d96815f9-040c-4008-8630-e1d05d409194",
        drainAPNM6: "405b6c1c-59aa-4201-af2d-25a7e733eb0c",
        drainAJZM5: "2cb018d4-1b3e-430a-83e8-64c5b4061b88",
        drainAJNM5: "8257dd1e-93d3-4ce0-afa2-c0e40bee335a",
        drainAPZM4: "9faabaa5-f951-40eb-96dc-4afe92733521",
        drainAPNM4: "7bd00625-b694-429a-8198-e773320df41a",
        drainAJZM3: "476c7941-1add-4c41-8446-d4ba9def3287",
        drainAJNM3: "763e1039-2509-49e5-b22e-8c54498d0d8d",
        drainAPZM2: "b6b08da2-1f18-4e51-8ca9-aadd7287fd0a",
        drainAPNM2: "ed876749-686d-4d07-b599-b0d5dcea6dd6",
        drainAJZM1: "3fe9ccd7-8053-4fd2-9406-9955d5745ab6",
        drainAJNM1: "88c83795-c58e-44fb-9e08-66e553ff305d",
        drainAPZM0: "e1c2c0c2-a5a9-4b6f-b5d4-2388f238557f",
        drainAPNM0: "e0cddc33-4696-4aee-af9b-7740ce188119",
        drainAPZ0Plus: "eb5c531b-857d-4a34-adf1-fc74b1a22931",
        drainAPN0Plus: "53dd4f7b-b312-40ba-af97-da3c50c06cc5",
        drainAJZ1Plus: "b31b2322-f235-497d-a505-7a0accd0095b",
        drainAJN1Plus: "3c48c625-1779-4186-98f6-1f1fb1310df7",
        drainAPZ2Plus: "759585fc-d615-4a71-9d18-75d6dadc98a3",
        drainAPN2Plus: "af61eb58-16db-4099-9d17-a5b89820fa4e",
        drainAJZ3Plus: "267620ce-5f40-436a-ab38-fc3da08e8d07",
        drainAJN3Plus: "178ee707-b8ee-421a-8e86-61c327e92a53",
        drainAPZ4Plus: "c6347073-aeee-40bb-8e5f-bcbf20f2b538",
        drainAPN4Plus: "01fa9b14-996d-4174-bb05-74bbb7288472",
        drainAPZM6Plus: "e190e3a0-ba75-44d2-b90c-7e54d8068e1f",
        drainAPNM6Plus: "9256ca3e-9baf-435a-be07-c420875b214c",
        drainAJZM5Plus: "c258a41a-456b-4615-a363-a133ed4adc7b",
        drainAJNM5Plus: "65cd8b56-cd49-4312-af18-bde7c837c00d",
        drainAPZM4Plus: "99eb0f0b-b37d-4186-82fe-885907c6cac2",
        drainAPNM4Plus: "cb6684d4-1b3b-490d-8d1f-5e40b83dba7c",
        drainAJZM3Plus: "09871639-512d-4eb8-8f40-af5d55b43b4d",
        drainAJNM3Plus: "bb98633f-e335-41b3-9330-68daf248a066",
        drainAPZM2Plus: "b9406b55-550e-4222-bc10-0338026574d2",
        drainAPNM2Plus: "b76673b4-399f-4020-83e5-5759d3fc88c2",
        drainAJZM1Plus: "d678fe55-bfb3-4273-8c89-3c33abc0bfd4",
        drainAJNM1Plus: "809b49dc-8269-4b02-b95f-fd6cc0539a89",

        drainBPZ0: "445af888-980c-4c0a-9dd1-bfbdf6d64f54",
        drainBPN0: "b978a194-cb16-4bbe-8e43-e99ecc04cd00",
        drainBJZ1: "04978901-8b35-4249-9679-4d0cec308f6e",
        drainBJN1: "c93bc336-717b-4c64-b609-dd2822dbb04d",
        drainBPZ2: "6241cf4c-6b1e-4559-9c78-177c7d0e7bf0",
        drainBPN2: "85246b18-1f75-4875-9a49-e00237619550",
        drainBJZ3: "847dda75-1265-4141-82d6-5f8565d812a7",
        drainBJN3: "6dfafe88-a730-4984-9828-420b00d554e3",
        drainBPZ4: "c94ebcd1-4464-406d-a89f-6f76cfb4bfc9",
        drainBPN4: "91d1e238-1e14-4f5c-8f0b-e2ddc263a8c5",
        drainBPZM6: "93af1e73-e574-4ba5-a62e-7aa73c0e8378",
        drainBPNM6: "49b81444-7d08-4d46-9a11-7d228409b3b9",
        drainBJZM5: "a731f4e7-6325-4b63-9321-144cff858bc7",
        drainBJNM5: "31ff9112-de73-4c2a-ae41-d2e235ee1d4b",
        drainBPZM4: "73bb5e48-b891-46ad-831c-a7e8672accca",
        drainBPNM4: "ec3b681a-8f94-41c8-afce-332be67f1e16",
        drainBJZM3: "f6a76587-b26e-451c-b695-2bcb4643e5b9",
        drainBJNM3: "44bf7e77-0b78-405f-b0be-c5280f242d0b",
        drainBPZM2: "28e0db5c-45aa-44d0-8e72-4efa69130b8a",
        drainBPNM2: "19b031ed-1d1f-4b67-ad08-875e831df505",
        drainBJZM1: "3b4f463a-9d76-4fbc-8ac4-ac049ef40b05",
        drainBJNM1: "10bcf32d-457d-451c-8eae-8591b7c5ba06",
        drainBPZM0: "c8e79312-9c36-4c73-b918-bad9b6b005d2",
        drainBPNM0: "17d27c34-10ab-4702-b993-668b2f79ee55",
        drainBPZ0Plus: "0769101a-7a7e-48be-bfbb-0a11b004dc15",
        drainBPN0Plus: "ab81778d-ed42-4046-862b-ec11e861dd27",
        drainBJZ1Plus: "b960ca86-8f07-4386-b0a7-35fd0cf3dd3b",
        drainBJN1Plus: "4154a3f1-e8a7-4e4e-8c68-e1318989be55",
        drainBPZ2Plus: "297418c2-d216-4937-b191-35a0544e0d9d",
        drainBPN2Plus: "97d2b29a-fb2c-4659-b6ba-c1c0fb19762e",
        drainBJZ3Plus: "279db536-7b5a-4196-b4e1-9b044b82c13f",
        drainBJN3Plus: "f8b671fa-4b5d-4266-8371-4d7897eee66d",
        drainBPZ4Plus: "6af8f8e6-401e-4129-8fba-9a37a804f1bb",
        drainBPN4Plus: "804973d1-6870-4110-9f8d-ab14c054ed0a",
        drainBPZM6Plus: "495d63c3-fe46-48d8-9a3d-c4ccb6f531d4",
        drainBPNM6Plus: "f8b7f01a-c547-443f-a561-99859fc18a59",
        drainBJZM5Plus: "928ff395-bfaf-4ac8-915d-eec0a9dbb475",
        drainBJNM5Plus: "c5cf08f7-cd1e-4350-a494-acff7445cb0a",
        drainBPZM4Plus: "191e37b6-af21-4eda-adef-935998f5ccf4",
        drainBPNM4Plus: "fcbc1791-24f5-46ba-8a1a-5d59851fe13a",
        drainBJZM3Plus: "ee66e1b5-d822-4a60-8ac7-30938b4f0eba",
        drainBJNM3Plus: "605f2973-6130-47af-b336-eb3187ee6ccf",
        drainBPZM2Plus: "339e8c42-52dc-4210-b813-d628f60c7b84",
        drainBPNM2Plus: "f7b3eb02-55fd-48d0-90e0-0d3918c0809b",
        drainBJZM1Plus: "5517274b-fe9a-4959-a9bd-7abe77903ee2",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {},

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        valvePZ0: "errorPZ0",
        valvePN0: "errorPN0",
        valveJZ1: "errorJZ1",
        valveJN1: "errorJN1",
        valvePZ2: "errorPZ2",
        valvePN2: "errorPN2",
        valveJZ3: "errorJZ3",
        valveJN3: "errorJN3",
        valvePZ4: "errorPZ4",
        valvePN4: "errorPN4",
        valvePZM6: "errorPZM6",
        valvePNM6: "errorPNM6",
        valveJZM5: "errorJZM5",
        valveJNM5: "errorJNM5",
        valvePZM4: "errorPZM4",
        valvePNM4: "errorPNM4",
        valveJZM3: "errorJZM3",
        valveJNM3: "errorJNM3",
        valvePZM2: "errorPZM2",
        valvePNM2: "errorPNM2",
        valveJZM1: "errorJZM1",
        valveJNM1: "errorJNM1",
        valvePZM0: "errorPZM0",
        valvePNM0: "errorPNM0",
        valvePZ0Plus: "errorPZ0Plus",
        valvePN0Plus: "errorPN0Plus",
        valveJZ1Plus: "errorJZ1Plus",
        valveJN1Plus: "errorJN1Plus",
        valvePZ2Plus: "errorPZ2Plus",
        valvePN2Plus: "errorPN2Plus",
        valveJZ3Plus: "errorJZ3Plus",
        valveJN3Plus: "errorJN3Plus",
        valvePZ4Plus: "errorPZ4Plus",
        valvePN4Plus: "errorPN4Plus",
        valvePZM6Plus: "errorPZM6Plus",
        valvePNM6Plus: "errorPNM6Plus",
        valveJZM5Plus: "errorJZM5Plus",
        valveJNM5Plus: "errorJNM5Plus",
        valvePZM4Plus: "errorPZM4Plus",
        valvePNM4Plus: "errorPNM4Plus",
        valveJZM3Plus: "errorJZM3Plus",
        valveJNM3Plus: "errorJNM3Plus",
        valvePZM2Plus: "errorPZM2Plus",
        valvePNM2Plus: "errorPNM2Plus",
        valveJZM1Plus: "errorJZM1Plus",
        valveJNM1Plus: "errorJNM1Plus",

        drainAPZ0: "errorPZ0, errorDrainAPZ0",
        drainAPN0: "errorPN0, errorDrainAPN0",
        drainAJZ1: "errorJZ1, errorDrainAJZ1",
        drainAJN1: "errorJN1, errorDrainAJN1",
        drainAPZ2: "errorPZ2, errorDrainAPZ2",
        drainAPN2: "errorPN2, errorDrainAPN2",
        drainAJZ3: "errorJZ3, errorDrainAJZ3",
        drainAJN3: "errorJN3, errorDrainAJN3",
        drainAPZ4: "errorPZ4, errorDrainAPZ4",
        drainAPN4: "errorPN4, errorDrainAPN4",
        drainAPZM6: "errorPZM6, errorDrainAPZM6",
        drainAPNM6: "errorPNM6, errorDrainAPNM6",
        drainAJZM5: "errorJZM5, errorDrainAJZM5",
        drainAJNM5: "errorJNM5, errorDrainAJNM5",
        drainAPZM4: "errorPZM4, errorDrainAPZM4",
        drainAPNM4: "errorPNM4, errorDrainAPNM4",
        drainAJZM3: "errorJZM3, errorDrainAJZM3",
        drainAJNM3: "errorJNM3, errorDrainAJNM3",
        drainAPZM2: "errorPZM2, errorDrainAPZM2",
        drainAPNM2: "errorPNM2, errorDrainAPNM2",
        drainAJZM1: "errorJZM1, errorDrainAJZM1",
        drainAJNM1: "errorJNM1, errorDrainAJNM1",
        drainAPZM0: "errorPZM0, errorDrainAPZM0",
        drainAPNM0: "errorPNM0, errorDrainAPNM0",
        drainAPZ0Plus: "errorPZ0Plus, errorDrainAPZ0Plus",
        drainAPN0Plus: "errorPN0Plus, errorDrainAPN0Plus",
        drainAJZ1Plus: "errorJZ1Plus, errorDrainAJZ1Plus",
        drainAJN1Plus: "errorJN1Plus, errorDrainAJN1Plus",
        drainAPZ2Plus: "errorPZ2Plus, errorDrainAPZ2Plus",
        drainAPN2Plus: "errorPN2Plus, errorDrainAPN2Plus",
        drainAJZ3Plus: "errorJZ3Plus, errorDrainAJZ3Plus",
        drainAJN3Plus: "errorJN3Plus, errorDrainAJN3Plus",
        drainAPZ4Plus: "errorPZ4Plus, errorDrainAPZ4Plus",
        drainAPN4Plus: "errorPN4Plus, errorDrainAPN4Plus",
        drainAPZM6Plus: "errorPZM6Plus, errorDrainAPZM6Plus",
        drainAPNM6Plus: "errorPNM6Plus, errorDrainAPNM6Plus",
        drainAJZM5Plus: "errorJZM5Plus, errorDrainAJZM5Plus",
        drainAJNM5Plus: "errorJNM5Plus, errorDrainAJNM5Plus",
        drainAPZM4Plus: "errorPZM4Plus, errorDrainAPZM4Plus",
        drainAPNM4Plus: "errorPNM4Plus, errorDrainAPNM4Plus",
        drainAJZM3Plus: "errorJZM3Plus, errorDrainAJZM3Plus",
        drainAJNM3Plus: "errorJNM3Plus, errorDrainAJNM3Plus",
        drainAPZM2Plus: "errorPZM2Plus, errorDrainAPZM2Plus",
        drainAPNM2Plus: "errorPNM2Plus, errorDrainAPNM2Plus",
        drainAJZM1Plus: "errorJZM1Plus, errorDrainAJZM1Plus",
        drainAJNM1Plus: "errorJNM1Plus, errorDrainAJNM1Plus",

        drainBPZ0: "errorPZ0, errorDrainBPZ0",
        drainBPN0: "errorPN0, errorDrainBPN0",
        drainBJZ1: "errorJZ1, errorDrainBJZ1",
        drainBJN1: "errorJN1, errorDrainBJN1",
        drainBPZ2: "errorPZ2, errorDrainBPZ2",
        drainBPN2: "errorPN2, errorDrainBPN2",
        drainBJZ3: "errorJZ3, errorDrainBJZ3",
        drainBJN3: "errorJN3, errorDrainBJN3",
        drainBPZ4: "errorPZ4, errorDrainBPZ4",
        drainBPN4: "errorPN4, errorDrainBPN4",
        drainBPZM6: "errorPZM6, errorDrainBPZM6",
        drainBPNM6: "errorPNM6, errorDrainBPNM6",
        drainBJZM5: "errorJZM5, errorDrainBJZM5",
        drainBJNM5: "errorJNM5, errorDrainBJNM5",
        drainBPZM4: "errorPZM4, errorDrainBPZM4",
        drainBPNM4: "errorPNM4, errorDrainBPNM4",
        drainBJZM3: "errorJZM3, errorDrainBJZM3",
        drainBJNM3: "errorJNM3, errorDrainBJNM3",
        drainBPZM2: "errorPZM2, errorDrainBPZM2",
        drainBPNM2: "errorPNM2, errorDrainBPNM2",
        drainBJZM1: "errorJZM1, errorDrainBJZM1",
        drainBJNM1: "errorJNM1, errorDrainBJNM1",
        drainBPZM0: "errorPZM0, errorDrainBPZM0",
        drainBPNM0: "errorPNM0, errorDrainBPNM0",
        drainBPZ0Plus: "errorPZ0Plus, errorDrainBPZ0Plus",
        drainBPN0Plus: "errorPN0Plus, errorDrainBPN0Plus",
        drainBJZ1Plus: "errorJZ1Plus, errorDrainBJZ1Plus",
        drainBJN1Plus: "errorJN1Plus, errorDrainBJN1Plus",
        drainBPZ2Plus: "errorPZ2Plus, errorDrainBPZ2Plus",
        drainBPN2Plus: "errorPN2Plus, errorDrainBPN2Plus",
        drainBJZ3Plus: "errorJZ3Plus, errorDrainBJZ3Plus",
        drainBJN3Plus: "errorJN3Plus, errorDrainBJN3Plus",
        drainBPZ4Plus: "errorPZ4Plus, errorDrainBPZ4Plus",
        drainBPN4Plus: "errorPN4Plus, errorDrainBPN4Plus",
        drainBPZM6Plus: "errorPZM6Plus, errorDrainBPZM6Plus",
        drainBPNM6Plus: "errorPNM6Plus, errorDrainBPNM6Plus",
        drainBJZM5Plus: "errorJZM5Plus, errorDrainBJZM5Plus",
        drainBJNM5Plus: "errorJNM5Plus, errorDrainBJNM5Plus",
        drainBPZM4Plus: "errorPZM4Plus, errorDrainBPZM4Plus",
        drainBPNM4Plus: "errorPNM4Plus, errorDrainBPNM4Plus",
        drainBJZM3Plus: "errorJZM3Plus, errorDrainBJZM3Plus",
        drainBJNM3Plus: "errorJNM3Plus, errorDrainBJNM3Plus",
        drainBPZM2Plus: "errorPZM2Plus, errorDrainBPZM2Plus",
        drainBPNM2Plus: "errorPNM2Plus, errorDrainBPNM2Plus",
        drainBJZM1Plus: "errorJZM1Plus, errorDrainBJZM1Plus",
        drainBJNM1Plus: "errorJNM1Plus, errorDrainBJNM1Plus",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        drainAPZ0: "drainATooltipPZ0",
        drainAPN0: "drainATooltipPN0",
        drainAJZ1: "drainATooltipJZ1",
        drainAJN1: "drainATooltipJN1",
        drainAPZ2: "drainATooltipPZ2",
        drainAPN2: "drainATooltipPN2",
        drainAJZ3: "drainATooltipJZ3",
        drainAJN3: "drainATooltipJN3",
        drainAPZ4: "drainATooltipPZ4",
        drainAPN4: "drainATooltipPN4",
        drainAPZM6: "drainATooltipPZM6",
        drainAPNM6: "drainATooltipPNM6",
        drainAJZM5: "drainATooltipJZM5",
        drainAJNM5: "drainATooltipJNM5",
        drainAPZM4: "drainATooltipPZM4",
        drainAPNM4: "drainATooltipPNM4",
        drainAJZM3: "drainATooltipJZM3",
        drainAJNM3: "drainATooltipJNM3",
        drainAPZM2: "drainATooltipPZM2",
        drainAPNM2: "drainATooltipPNM2",
        drainAJZM1: "drainATooltipJZM1",
        drainAJNM1: "drainATooltipJNM1",
        drainAPZM0: "drainATooltipPZM0",
        drainAPNM0: "drainATooltipPNM0",
        drainAPZ0Plus: "drainATooltipPZ0Plus",
        drainAPN0Plus: "drainATooltipPN0Plus",
        drainAJZ1Plus: "drainATooltipJZ1Plus",
        drainAJN1Plus: "drainATooltipJN1Plus",
        drainAPZ2Plus: "drainATooltipPZ2Plus",
        drainAPN2Plus: "drainATooltipPN2Plus",
        drainAJZ3Plus: "drainATooltipJZ3Plus",
        drainAJN3Plus: "drainATooltipJN3Plus",
        drainAPZ4Plus: "drainATooltipPZ4Plus",
        drainAPN4Plus: "drainATooltipPN4Plus",
        drainAPZM6Plus: "drainATooltipPZM6Plus",
        drainAPNM6Plus: "drainATooltipPNM6Plus",
        drainAJZM5Plus: "drainATooltipJZM5Plus",
        drainAJNM5Plus: "drainATooltipJNM5Plus",
        drainAPZM4Plus: "drainATooltipPZM4Plus",
        drainAPNM4Plus: "drainATooltipPNM4Plus",
        drainAJZM3Plus: "drainATooltipJZM3Plus",
        drainAJNM3Plus: "drainATooltipJNM3Plus",
        drainAPZM2Plus: "drainATooltipPZM2Plus",
        drainAPNM2Plus: "drainATooltipPNM2Plus",
        drainAJZM1Plus: "drainATooltipJZM1Plus",
        drainAJNM1Plus: "drainATooltipJNM1Plus",

        drainBPZ0: "drainBTooltipPZ0",
        drainBPN0: "drainBTooltipPN0",
        drainBJZ1: "drainBTooltipJZ1",
        drainBJN1: "drainBTooltipJN1",
        drainBPZ2: "drainBTooltipPZ2",
        drainBPN2: "drainBTooltipPN2",
        drainBJZ3: "drainBTooltipJZ3",
        drainBJN3: "drainBTooltipJN3",
        drainBPZ4: "drainBTooltipPZ4",
        drainBPN4: "drainBTooltipPN4",
        drainBPZM6: "drainBTooltipPZM6",
        drainBPNM6: "drainBTooltipPNM6",
        drainBJZM5: "drainBTooltipJZM5",
        drainBJNM5: "drainBTooltipJNM5",
        drainBPZM4: "drainBTooltipPZM4",
        drainBPNM4: "drainBTooltipPNM4",
        drainBJZM3: "drainBTooltipJZM3",
        drainBJNM3: "drainBTooltipJNM3",
        drainBPZM2: "drainBTooltipPZM2",
        drainBPNM2: "drainBTooltipPNM2",
        drainBJZM1: "drainBTooltipJZM1",
        drainBJNM1: "drainBTooltipJNM1",
        drainBPZM0: "drainBTooltipPZM0",
        drainBPNM0: "drainBTooltipPNM0",
        drainBPZ0Plus: "drainBTooltipPZ0Plus",
        drainBPN0Plus: "drainBTooltipPN0Plus",
        drainBJZ1Plus: "drainBTooltipJZ1Plus",
        drainBJN1Plus: "drainBTooltipJN1Plus",
        drainBPZ2Plus: "drainBTooltipPZ2Plus",
        drainBPN2Plus: "drainBTooltipPN2Plus",
        drainBJZ3Plus: "drainBTooltipJZ3Plus",
        drainBJN3Plus: "drainBTooltipJN3Plus",
        drainBPZ4Plus: "drainBTooltipPZ4Plus",
        drainBPN4Plus: "drainBTooltipPN4Plus",
        drainBPZM6Plus: "drainBTooltipPZM6Plus",
        drainBPNM6Plus: "drainBTooltipPNM6Plus",
        drainBJZM5Plus: "drainBTooltipJZM5Plus",
        drainBJNM5Plus: "drainBTooltipJNM5Plus",
        drainBPZM4Plus: "drainBTooltipPZM4Plus",
        drainBPNM4Plus: "drainBTooltipPNM4Plus",
        drainBJZM3Plus: "drainBTooltipJZM3Plus",
        drainBJNM3Plus: "drainBTooltipJNM3Plus",
        drainBPZM2Plus: "drainBTooltipPZM2Plus",
        drainBPNM2Plus: "drainBTooltipPNM2Plus",
        drainBJZM1Plus: "drainBTooltipJZM1Plus",
        drainBJNM1Plus: "drainBTooltipJNM1Plus",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        drainAPZ0: "drainAClassPZ0",
        drainAPN0: "drainAClassPN0",
        drainAJZ1: "drainAClassJZ1",
        drainAJN1: "drainAClassJN1",
        drainAPZ2: "drainAClassPZ2",
        drainAPN2: "drainAClassPN2",
        drainAJZ3: "drainAClassJZ3",
        drainAJN3: "drainAClassJN3",
        drainAPZ4: "drainAClassPZ4",
        drainAPN4: "drainAClassPN4",
        drainAPZM6: "drainAClassPZM6",
        drainAPNM6: "drainAClassPNM6",
        drainAJZM5: "drainAClassJZM5",
        drainAJNM5: "drainAClassJNM5",
        drainAPZM4: "drainAClassPZM4",
        drainAPNM4: "drainAClassPNM4",
        drainAJZM3: "drainAClassJZM3",
        drainAJNM3: "drainAClassJNM3",
        drainAPZM2: "drainAClassPZM2",
        drainAPNM2: "drainAClassPNM2",
        drainAJZM1: "drainAClassJZM1",
        drainAJNM1: "drainAClassJNM1",
        drainAPZM0: "drainAClassPZM0",
        drainAPNM0: "drainAClassPNM0",
        drainAPZ0Plus: "drainAClassPZ0Plus",
        drainAPN0Plus: "drainAClassPN0Plus",
        drainAJZ1Plus: "drainAClassJZ1Plus",
        drainAJN1Plus: "drainAClassJN1Plus",
        drainAPZ2Plus: "drainAClassPZ2Plus",
        drainAPN2Plus: "drainAClassPN2Plus",
        drainAJZ3Plus: "drainAClassJZ3Plus",
        drainAJN3Plus: "drainAClassJN3Plus",
        drainAPZ4Plus: "drainAClassPZ4Plus",
        drainAPN4Plus: "drainAClassPN4Plus",
        drainAPZM6Plus: "drainAClassPZM6Plus",
        drainAPNM6Plus: "drainAClassPNM6Plus",
        drainAJZM5Plus: "drainAClassJZM5Plus",
        drainAJNM5Plus: "drainAClassJNM5Plus",
        drainAPZM4Plus: "drainAClassPZM4Plus",
        drainAPNM4Plus: "drainAClassPNM4Plus",
        drainAJZM3Plus: "drainAClassJZM3Plus",
        drainAJNM3Plus: "drainAClassJNM3Plus",
        drainAPZM2Plus: "drainAClassPZM2Plus",
        drainAPNM2Plus: "drainAClassPNM2Plus",
        drainAJZM1Plus: "drainAClassJZM1Plus",
        drainAJNM1Plus: "drainAClassJNM1Plus",

        drainBPZ0: "drainBClassPZ0",
        drainBPN0: "drainBClassPN0",
        drainBJZ1: "drainBClassJZ1",
        drainBJN1: "drainBClassJN1",
        drainBPZ2: "drainBClassPZ2",
        drainBPN2: "drainBClassPN2",
        drainBJZ3: "drainBClassJZ3",
        drainBJN3: "drainBClassJN3",
        drainBPZ4: "drainBClassPZ4",
        drainBPN4: "drainBClassPN4",
        drainBPZM6: "drainBClassPZM6",
        drainBPNM6: "drainBClassPNM6",
        drainBJZM5: "drainBClassJZM5",
        drainBJNM5: "drainBClassJNM5",
        drainBPZM4: "drainBClassPZM4",
        drainBPNM4: "drainBClassPNM4",
        drainBJZM3: "drainBClassJZM3",
        drainBJNM3: "drainBClassJNM3",
        drainBPZM2: "drainBClassPZM2",
        drainBPNM2: "drainBClassPNM2",
        drainBJZM1: "drainBClassJZM1",
        drainBJNM1: "drainBClassJNM1",
        drainBPZM0: "drainBClassPZM0",
        drainBPNM0: "drainBClassPNM0",
        drainBPZ0Plus: "drainBClassPZ0Plus",
        drainBPN0Plus: "drainBClassPN0Plus",
        drainBJZ1Plus: "drainBClassJZ1Plus",
        drainBJN1Plus: "drainBClassJN1Plus",
        drainBPZ2Plus: "drainBClassPZ2Plus",
        drainBPN2Plus: "drainBClassPN2Plus",
        drainBJZ3Plus: "drainBClassJZ3Plus",
        drainBJN3Plus: "drainBClassJN3Plus",
        drainBPZ4Plus: "drainBClassPZ4Plus",
        drainBPN4Plus: "drainBClassPN4Plus",
        drainBPZM6Plus: "drainBClassPZM6Plus",
        drainBPNM6Plus: "drainBClassPNM6Plus",
        drainBJZM5Plus: "drainBClassJZM5Plus",
        drainBJNM5Plus: "drainBClassJNM5Plus",
        drainBPZM4Plus: "drainBClassPZM4Plus",
        drainBPNM4Plus: "drainBClassPNM4Plus",
        drainBJZM3Plus: "drainBClassJZM3Plus",
        drainBJNM3Plus: "drainBClassJNM3Plus",
        drainBPZM2Plus: "drainBClassPZM2Plus",
        drainBPNM2Plus: "drainBClassPNM2Plus",
        drainBJZM1Plus: "drainBClassJZM1Plus",
        drainBJNM1Plus: "drainBClassJNM1Plus",
      },

      //station id list
      stationIdList: [
        "86eafaa0-49be-4580-9f6a-92c293e3936d",
        "431deef2-b5f1-4e70-83ca-5a75e259d6a0",
        "4ade1b4b-0eda-459a-88db-95cdf09387ff",
        "9658719c-40d9-4c73-bc71-f0fe706733f9",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            let errorNameList = [errorName];
            if (errorName.indexOf(",") > 0) {
              errorNameList = errorName.split(",");
            }

            for (let errorNameItem of errorNameList) {
              this[errorNameItem] = this.getErrorLevelFromMultipleDevice(this[errorNameItem], stationData[dataId].errorLevel);
            }
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    assembleTooltip_drain(name, errorLevel, runningFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else {
        if (runningFlag > 0) {
          result += "开启";
        } else if (runningFlag === 0) {
          result += "关闭";
        }
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-right-1 {
          top: 184px;
          left: 1132px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-3 {
          top: 153px;
          left: 1050px;
          &::before {
            bottom: -40px;
            left: -34px;
            width: 100px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -89px;
            left: 24px;
          }
          .state-info {
            right: -165px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-5 {
          top: 117px;
          left: 962px;
          &::before {
            bottom: 35px;
            left: -17px;
            width: 60px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 64px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-13 {
          top: 117px;
          left: 937px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-11 {
          top: 150px;
          left: 835px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-9 {
          top: 170px;
          left: 732px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-7 {
          top: 180px;
          left: 625px;
          &::before {
            bottom: -5px;
            left: -4px;
            width: 25px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -61px;
            top: 59px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-5 {
          top: 170px;
          left: 518px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-3 {
          top: 150px;
          left: 405px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-1 {
          top: 117px;
          left: 300px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-5 {
          top: 117px;
          left: 275px;
          &::before {
            bottom: 35px;
            left: -28px;
            width: 60px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 64px;
            left: -18px;
          }
          .state-info {
            right: 35px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-3 {
          top: 157px;
          left: 175px;
          &::before {
            bottom: -40px;
            left: -51px;
            width: 100px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -89px;
            left: -24px;
          }
          .state-info {
            right: 40px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-1 {
          top: 182px;
          left: 72px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-2 {
          top: 168px;
          left: 1093px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-4 {
          top: 132px;
          left: 998px;
          &::before {
            bottom: 38px;
            left: -21px;
            width: 70px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 73px;
            left: 20px;
          }
          .state-info {
            right: -165px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-12 {
          top: 135px;
          left: 885px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-10 {
          top: 158px;
          left: 805px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-8 {
          top: 177px;
          left: 675px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-6 {
          top: 177px;
          left: 570px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-4 {
          top: 158px;
          left: 440px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-2 {
          top: 135px;
          left: 350px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-4 {
          top: 132px;
          left: 240px;
          &::before {
            bottom: 38px;
            left: -33px;
            width: 70px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 73px;
            left: -19px;
          }
          .state-info {
            right: 34px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-2 {
          top: 168px;
          left: 145px;
          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -25px;
          }
          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }
      }
    }
  }

  .drain-container {
    display: flex;
    justify-content: flex-end;
  }

  .valve-sign {
    margin-top: auto;
    margin-bottom: auto;
    width: 12px;
    height: 12px;
    background-color: #ffff00;
    animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
    border-radius: 10px;
    margin-left: 12px;

    &.running {
      background-color: #67dd34;
      animation: none;
    }
    &.stopped {
      background-color: #a0a0a0;
      animation: none;
    }
  }
}
</style>